<template>
  <div id="login">
    <div class="limiter-login">
      <div class="container-login">
        <div class="wrap-login">
          <div class="form-login">
            <div class="form-login--content">
              <div class="form-login-img">
                <img
                  v-if="schema.logo"
                  :src="schema.logo.src"
                  :alt="schema.companyName"
                  :width="schema.logo.srcWidth"
                  :height="schema.logo.srcHeight"
                />
              </div>

              <slot name="form"></slot>
            </div>
            <footer class="footer-account">© {{ currentYear }} Copyright {{ schema.companyName }}</footer>
          </div>
          <div class="bg-login" :style="background"></div>
        </div>
      </div>
    </div>
    <slot name="acceptTerms"></slot>
  </div>
</template>

<script>
export default {
  props: {
    schema: { type: Object, default: () => ({}), required: true }
  },

  data: () => ({
    background: '',
    currentYear: new Date().getFullYear()
  }),

  created() {
    this.background = this.schema.backgroundImage
      ? `background-image: url('${this.schema.backgroundImage}')`
      : `background-color: ${this.schema.backgroundColor}`;
  }
};
</script>
